import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c39682a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "compact-search-container" }
const _hoisted_3 = { class: "p-inputgroup compact-search" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" })
], -1))
const _hoisted_5 = { class: "p-mx-2" }
const _hoisted_6 = { class: "p-mt-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))
const _hoisted_8 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_9 = {
  key: 0,
  class: "p-field"
}
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = { class: "p-field" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Branch code * ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " (Must be unique) ", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "p-error" }
const _hoisted_19 = {
  key: 1,
  class: "p-error"
}
const _hoisted_20 = { class: "p-field" }
const _hoisted_21 = {
  key: 0,
  class: "p-error"
}
const _hoisted_22 = { class: "p-field" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1))
const _hoisted_24 = { class: "p-field" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "license_no" }, "License No", -1))
const _hoisted_26 = { class: "p-field" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "p-error" }
const _hoisted_29 = {
  key: 1,
  class: "p-error"
}
const _hoisted_30 = { class: "p-field" }
const _hoisted_31 = {
  key: 0,
  class: "p-error"
}
const _hoisted_32 = {
  key: 1,
  class: "p-error"
}
const _hoisted_33 = {
  key: 1,
  class: "p-grid"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "p-mt-5" }, "Tax Settings", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-12" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("small", null, [
      /*#__PURE__*/_createTextVNode("1: "),
      /*#__PURE__*/_createElementVNode("i", null, " Choose show to make tax visible for this store. ")
    ]),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("small", null, [
      /*#__PURE__*/_createTextVNode("2: "),
      /*#__PURE__*/_createElementVNode("i", null, " Wrtie name of the tax in tax name field and write a value for this tax in value (%) field. ")
    ]),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("small", null, [
      /*#__PURE__*/_createTextVNode("3: "),
      /*#__PURE__*/_createElementVNode("i", null, " Choose required or optional if you want to apply this tax to all or specific customers. ")
    ]),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("small", null, [
      /*#__PURE__*/_createTextVNode("4: "),
      /*#__PURE__*/_createElementVNode("i", null, " Choose accounting head for this tax. ")
    ]),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1))
const _hoisted_36 = { class: "p-col-12" }
const _hoisted_37 = { class: "p-inputgroup" }
const _hoisted_38 = { class: "p-inputgroup-addon" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "show1",
  class: "p-px-1 p-mt-2"
}, "Show", -1))
const _hoisted_40 = { class: "p-inputgroup-addon" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "required_1",
  class: "p-px-1 p-mt-2"
}, "Required", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "optional_1",
  class: "p-px-1 p-mt-2 p-ml-2"
}, "Optional", -1))
const _hoisted_43 = { class: "p-col-12" }
const _hoisted_44 = { class: "p-inputgroup" }
const _hoisted_45 = { class: "p-inputgroup-addon" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "show2",
  class: "p-px-1 p-mt-2"
}, "Show", -1))
const _hoisted_47 = { class: "p-inputgroup-addon" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "required_2",
  class: "p-px-1 p-mt-2"
}, "Required", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "optional_2",
  class: "p-px-1 p-mt-2 p-ml-2"
}, "Optional", -1))
const _hoisted_50 = { class: "p-col-12" }
const _hoisted_51 = { class: "p-inputgroup" }
const _hoisted_52 = { class: "p-inputgroup-addon" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "show3",
  class: "p-px-1 p-mt-2"
}, "Show", -1))
const _hoisted_54 = { class: "p-inputgroup-addon" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "required_3",
  class: "p-px-1 p-mt-2"
}, "Required", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "optional_3",
  class: "p-px-1 p-mt-2 p-ml-2"
}, "Optional", -1))
const _hoisted_57 = { class: "confirmation-content" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_59 = /*#__PURE__*/_createTextVNode("Are you sure to delete ")
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" ?")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_InputText, {
                modelValue: _ctx.keyword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
                modelModifiers: { trim: true },
                placeholder: "Search by name, code, pharmacy, email...",
                class: "compact-search-input",
                onKeydown: _withKeys(_ctx.loadSearchData, ["enter"])
              }, null, 8, ["modelValue", "onKeydown"]),
              (_ctx.keyword)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-times",
                    class: "p-button-outlined p-button-secondary clear-btn",
                    onClick: _ctx.clearSearch,
                    title: "Clear search"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (this.can('create_branch'))
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  icon: "pi pi-plus",
                  class: "p-button-success",
                  onClick: _ctx.openDialog,
                  title: "Add Branch"
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_DataTable, {
          first: _ctx.goToFirstLink,
          "onUpdate:first": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.goToFirstLink) = $event)),
          firstModifiers: { sync: true },
          value: _ctx.lists,
          lazy: true,
          paginator: _ctx.checkPagination,
          rows: _ctx.limit,
          totalRecords: _ctx.totalRecords,
          scrollable: true,
          onPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPage($event))),
          class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
        }, {
          empty: _withCtx(() => [
            _hoisted_7
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "pharmacy_name",
              header: "Pharmacy"
            }),
            _createVNode(_component_Column, {
              field: "name",
              header: "Branch"
            }),
            _createVNode(_component_Column, {
              field: "code",
              header: "Code"
            }),
            _createVNode(_component_Column, {
              field: "address",
              header: "Address"
            }),
            _createVNode(_component_Column, {
              field: "description",
              header: "Description"
            }),
            _createVNode(_component_Column, {
              field: "license_no",
              header: "License No"
            }),
            _createVNode(_component_Column, {
              field: "email",
              header: "Email Address"
            }),
            _createVNode(_component_Column, {
              field: "contact",
              header: "Contact No"
            }),
            _createVNode(_component_Column, {
              exportable: false,
              header: "Action"
            }, {
              body: _withCtx((slotProps) => [
                (this.can('edit_branch'))
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      icon: "pi pi-pencil",
                      class: "p-button-rounded p-button-primary p-mr-2",
                      onClick: ($event: any) => (_ctx.editIem(slotProps.data))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (this.can('delete_branch'))
                  ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      icon: "pi pi-trash",
                      class: "p-button-rounded p-button-danger",
                      onClick: ($event: any) => (_ctx.confirmChangeStatus(slotProps.data))
                    }, null, 8, ["onClick"])), [
                      [_vShow, false]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["first", "value", "paginator", "rows", "totalRecords"])
      ]),
      _createVNode(_component_Dialog, {
        visible: _ctx.productDialog,
        "onUpdate:visible": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.productDialog) = $event)),
        style: { width: '70vw' },
        maximizable: true,
        position: "top",
        class: "p-fluid",
        onKeydown: _cache[38] || (_cache[38] = _withKeys(_withModifiers(($event: any) => (_ctx.saveItem(!_ctx.v$.$invalid)), ["prevent","stop"]), ["enter"]))
      }, {
        header: _withCtx(() => [
          _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.dialogTitle), 1)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "submit",
            label: "Save",
            icon: "pi pi-check",
            class: "p-button-primary",
            onKeydown: _cache[35] || (_cache[35] = _withKeys(_withModifiers(($event: any) => (_ctx.saveItem()), ["prevent","stop"]), ["enter"])),
            onClick: _cache[36] || (_cache[36] = _withModifiers(($event: any) => (_ctx.saveItem(!_ctx.v$.$invalid)), ["prevent"]))
          })
        ]),
        default: _withCtx(() => [
          (!_ctx.editPage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("label", {
                  for: "accountType",
                  class: _normalizeClass({ 'p-error': _ctx.item.pharmacyID == 0 && _ctx.submitted })
                }, "Pharmacy *", 2),
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.item.pharmacyID,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.pharmacyID) = $event)),
                  options: _ctx.pharmacyList,
                  optionLabel: "name",
                  optionValue: "id",
                  class: _normalizeClass({ 'p-invalid': _ctx.item.pharmacyID == 0 && _ctx.submitted })
                }, null, 8, ["modelValue", "options", "class"]),
                (_ctx.item.pharmacyID == 0 && _ctx.submitted)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_10, "Pharmacy is required"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", {
              for: "name",
              class: _normalizeClass({ 'p-error': _ctx.v$.name.$invalid && _ctx.submitted })
            }, "Branch name *", 2),
            _createVNode(_component_InputText, {
              id: "name",
              modelValue: _ctx.v$.name.$model,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.name.$model) = $event)),
              class: _normalizeClass({ 'p-invalid': _ctx.v$.name.$invalid && _ctx.submitted }),
              autoFocus: ""
            }, null, 8, ["modelValue", "class"]),
            (
                            (_ctx.v$.name.$invalid && _ctx.submitted) ||
                            _ctx.v$.name.$pending.$response
                        )
              ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.v$.name.required.$message.replace(
                                "Value",
                                "Branch name"
                            )), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", {
              for: "code",
              class: _normalizeClass({ 'p-error': _ctx.v$.code.$invalid && _ctx.submitted })
            }, _hoisted_16, 2),
            _createVNode(_component_InputText, {
              id: "code",
              modelValue: _ctx.v$.code.$model,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.code.$model) = $event)),
              class: _normalizeClass({ 'p-invalid': _ctx.v$.code.$invalid && _ctx.submitted })
            }, null, 8, ["modelValue", "class"]),
            (_ctx.v$.code.$error && _ctx.submitted)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.code.$errors, (error, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      id: "email-error",
                      key: index
                    }, [
                      _createElementVNode("small", _hoisted_18, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ]))
              : (
                            (_ctx.v$.code.$invalid && _ctx.submitted) ||
                            _ctx.v$.code.$pending.$response
                        )
                ? (_openBlock(), _createElementBlock("small", _hoisted_19, _toDisplayString(_ctx.v$.code.required.$message.replace(
                                "Value",
                                "Branch code"
                            )), 1))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", {
              for: "address",
              class: _normalizeClass({ 'p-error': _ctx.v$.address.$invalid && _ctx.submitted })
            }, "Address *", 2),
            _createVNode(_component_InputText, {
              id: "address",
              modelValue: _ctx.v$.address.$model,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.address.$model) = $event)),
              class: _normalizeClass({
                            'p-invalid': _ctx.v$.address.$invalid && _ctx.submitted,
                        })
            }, null, 8, ["modelValue", "class"]),
            (
                            (_ctx.v$.address.$invalid && _ctx.submitted) ||
                            _ctx.v$.address.$pending.$response
                        )
              ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(_ctx.v$.address.required.$message.replace(
                                "Value",
                                "Address"
                            )), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode(_component_InputText, {
              id: "description",
              modelValue: _ctx.item.description,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.item.description) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_InputText, {
              id: "license_no",
              modelValue: _ctx.item.licenseNo,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.item.licenseNo) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("label", {
              for: "email",
              class: _normalizeClass({
                            'p-error': _ctx.v$.email.$invalid && _ctx.submitted,
                        })
            }, "Email Address", 2),
            _createVNode(_component_InputText, {
              id: "email",
              modelValue: _ctx.v$.email.$model,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.v$.email.$model) = $event)),
              class: _normalizeClass({
                            'p-invalid': _ctx.v$.email.$invalid && _ctx.submitted,
                        }),
              "aria-describedby": "email-error"
            }, null, 8, ["modelValue", "class"]),
            (_ctx.v$.email.$error && _ctx.submitted)
              ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      id: "email-error",
                      key: index
                    }, [
                      _createElementVNode("small", _hoisted_28, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ]))
              : (
                            (_ctx.v$.email.$invalid && _ctx.submitted) ||
                            _ctx.v$.email.$pending.$response
                        )
                ? (_openBlock(), _createElementBlock("small", _hoisted_29, _toDisplayString(_ctx.v$.email.required.$message.replace(
                                "Value",
                                "Email"
                            )), 1))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("label", {
              for: "contactNo",
              class: _normalizeClass({
                            'p-error':
                                (_ctx.v$.contactNo.$invalid && _ctx.submitted) ||
                                _ctx.beErrors.hasOwnProperty('contact_no'),
                        })
            }, "Contact Number ", 2),
            _createVNode(_component_InputText, {
              id: "contactNo",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.clearErrors('contact_no'))),
              modelValue: _ctx.v$.contactNo.$model,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.v$.contactNo.$model) = $event)),
              modelModifiers: { trim: true },
              class: _normalizeClass({
                            'p-invalid':
                                (_ctx.v$.contactNo.$invalid && _ctx.submitted) ||
                                _ctx.beErrors.hasOwnProperty('contact_no'),
                        }),
              onKeydown: [
                _cache[12] || (_cache[12] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext('emailAddress')), ["prevent"]), ["down"])),
                _cache[13] || (_cache[13] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext('accountTitle')), ["prevent"]), ["up"]))
              ]
            }, null, 8, ["modelValue", "class"]),
            (
                            (_ctx.v$.contactNo.$invalid && _ctx.submitted) ||
                            _ctx.v$.contactNo.$pending.$response
                        )
              ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(_ctx.v$.contactNo.$silentErrors[0].$message), 1))
              : _createCommentVNode("", true),
            (_ctx.beErrors.hasOwnProperty('contact_no'))
              ? (_openBlock(), _createElementBlock("small", _hoisted_32, _toDisplayString(_ctx.beErrors.hasOwnProperty("contact_no")
                                ? _ctx.beErrors["contact_no"][0]
                                : ""), 1))
              : _createCommentVNode("", true)
          ]),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _hoisted_34,
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("span", _hoisted_38, [
                      _hoisted_39,
                      _createVNode(_component_Checkbox, {
                        id: "show1",
                        modelValue: _ctx.item.show1,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.item.show1) = $event)),
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setTaxesDefault('first'))),
                        binary: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_InputText, {
                      placeholder: "Tax Name 1",
                      style: {"width":"30%"},
                      modelValue: _ctx.item.taxName1,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.item.taxName1) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_InputNumber, {
                      mode: "decimal",
                      style: {"width":"30%"},
                      useGrouping: false,
                      maxFractionDigits: 2,
                      minFractionDigits: 2,
                      placeholder: "Tax (%)",
                      modelValue: _ctx.item.taxValue1,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.item.taxValue1) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("span", _hoisted_40, [
                      _hoisted_41,
                      _createVNode(_component_RadioButton, {
                        id: "required_1",
                        value: "Required",
                        modelValue: _ctx.item.requiredOptional1,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.item.requiredOptional1) = $event))
                      }, null, 8, ["modelValue"]),
                      _hoisted_42,
                      _createVNode(_component_RadioButton, {
                        id: "optional_1",
                        value: "Optional",
                        modelValue: _ctx.item.requiredOptional1,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.item.requiredOptional1) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_Dropdown, {
                      style: {"width":"20%"},
                      id: "linkedAccount",
                      modelValue: _ctx.item.link1,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.item.link1) = $event)),
                      optionLabel: "account_name",
                      optionValue: "id",
                      options: _ctx.chartList,
                      filter: true
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("span", _hoisted_45, [
                      _hoisted_46,
                      _createVNode(_component_Checkbox, {
                        id: "show2",
                        modelValue: _ctx.item.show2,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.item.show2) = $event)),
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.setTaxesDefault('second'))),
                        binary: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_InputText, {
                      placeholder: "Tax Name 2",
                      style: {"width":"30%"},
                      modelValue: _ctx.item.taxName2,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.item.taxName2) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_InputNumber, {
                      mode: "decimal",
                      style: {"width":"30%"},
                      useGrouping: false,
                      maxFractionDigits: 2,
                      minFractionDigits: 2,
                      placeholder: "Tax (%)",
                      modelValue: _ctx.item.taxValue2,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.item.taxValue2) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("span", _hoisted_47, [
                      _hoisted_48,
                      _createVNode(_component_RadioButton, {
                        id: "required_2",
                        value: "Required",
                        modelValue: _ctx.item.requiredOptional2,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.item.requiredOptional2) = $event))
                      }, null, 8, ["modelValue"]),
                      _hoisted_49,
                      _createVNode(_component_RadioButton, {
                        id: "optional_2",
                        value: "Optional",
                        modelValue: _ctx.item.requiredOptional2,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.item.requiredOptional2) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_Dropdown, {
                      style: {"width":"20%"},
                      id: "linkedAccount",
                      modelValue: _ctx.item.link2,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.item.link2) = $event)),
                      optionLabel: "account_name",
                      optionValue: "id",
                      options: _ctx.chartList
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("span", _hoisted_52, [
                      _hoisted_53,
                      _createVNode(_component_Checkbox, {
                        id: "show3",
                        modelValue: _ctx.item.show3,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.item.show3) = $event)),
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.setTaxesDefault('third'))),
                        binary: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_InputText, {
                      placeholder: "Tax Name 3",
                      style: {"width":"30%"},
                      modelValue: _ctx.item.taxName3,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.item.taxName3) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_InputNumber, {
                      mode: "decimal",
                      style: {"width":"30%"},
                      useGrouping: false,
                      maxFractionDigits: 2,
                      minFractionDigits: 2,
                      placeholder: "Tax (%)",
                      modelValue: _ctx.item.taxValue3,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.item.taxValue3) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("span", _hoisted_54, [
                      _hoisted_55,
                      _createVNode(_component_RadioButton, {
                        id: "required_3",
                        value: "Required",
                        modelValue: _ctx.item.requiredOptional3,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.item.requiredOptional3) = $event))
                      }, null, 8, ["modelValue"]),
                      _hoisted_56,
                      _createVNode(_component_RadioButton, {
                        id: "optional_3",
                        value: "Optional",
                        modelValue: _ctx.item.requiredOptional3,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.item.requiredOptional3) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_Dropdown, {
                      style: {"width":"20%"},
                      id: "linkedAccount",
                      modelValue: _ctx.item.link3,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.item.link3) = $event)),
                      optionLabel: "account_name",
                      optionValue: "id",
                      options: _ctx.chartList
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.statusDialog,
        "onUpdate:visible": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.statusDialog) = $event)),
        style: { width: '450px' },
        header: "Confirm"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "No",
            icon: "pi pi-times",
            class: "p-button-success",
            onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.statusDialog = false))
          }),
          _createVNode(_component_Button, {
            label: "Yes",
            icon: "pi pi-check",
            class: "p-button-danger",
            onClick: _ctx.changeStatus
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_57, [
            _hoisted_58,
            _createElementVNode("span", null, [
              _hoisted_59,
              _createElementVNode("b", null, _toDisplayString(_ctx.state.name), 1),
              _hoisted_60
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}